"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _jquery = _interopRequireDefault(require("jquery"));

var _params = require("hub-http/helpers/params");

var _getCookie = _interopRequireDefault(require("../utils/getCookie"));

var _urls = require("../utils/urls");

var HomeDAO = /*#__PURE__*/function () {
  function HomeDAO() {
    (0, _classCallCheck2.default)(this, HomeDAO);
  }

  (0, _createClass2.default)(HomeDAO, null, [{
    key: "get",
    value: function get() {
      var portalIdFromQueryParam = _PortalIdParser.default.getPortalIdFromQueryParam();

      var apiPath = portalIdFromQueryParam ? '/home/v2/api' : '/home/v2/api/no-intended-portal';
      var params = portalIdFromQueryParam ? {
        portalId: portalIdFromQueryParam
      } : {};

      if (window.location && window.location.search) {
        var searchParams = (0, _params.parse)(window.location.search.replace(/^\?/, ''));
        Object.keys(searchParams).forEach(function (key) {
          params[key] = searchParams[key];
        });
      }

      return _jquery.default.ajax((0, _urls.api)(apiPath), {
        data: params,
        headers: {
          'X-HubSpot-CSRF-hubspotapi': (0, _getCookie.default)('csrf.app')
        },
        xhrFields: {
          withCredentials: true
        }
      });
    }
  }]);
  return HomeDAO;
}();

exports.default = HomeDAO;
module.exports = exports.default;